var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Gateway"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gateway",
    clipPath: "url(#clip-Gateway)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    transform: "translate(14 194)",
    fill: "#707070",
    stroke: "#444343",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 485,
    height: 125,
    rx: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 482,
    height: 122,
    rx: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-2",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-2",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-3",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-3",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-4",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-4",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(33 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-5",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-5",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(60 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-6",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-6",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214",
    transform: "translate(87 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-7",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-7",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215",
    transform: "translate(114 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-8",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#605757",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-8",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-9",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#3cf107",
    stroke: "#3cf107",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-9",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(-12 31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_107-10",
    "data-name": "Ellipse 107",
    transform: "translate(158 229)",
    fill: "#3cf107",
    stroke: "#3cf107",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 13,
    ry: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 14.5,
    rx: 12.5,
    ry: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_108-10",
    "data-name": "Ellipse 108",
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    transform: "translate(161 237)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(199.5 217.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "1")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(229.5 217.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(256.5 217.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "3")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": 4,
    transform: "translate(282.5 217.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "4")), /*#__PURE__*/React.createElement("text", {
    id: "_5",
    "data-name": 5,
    transform: "translate(199.5 292.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "5")), /*#__PURE__*/React.createElement("text", {
    id: "_6",
    "data-name": 6,
    transform: "translate(229.5 292.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "6")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(256.5 292.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "7")), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(282.5 292.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 9,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 10
  }, "8")), /*#__PURE__*/React.createElement("text", {
    id: "CONNECT-MGW8S_IRIS_IVDX_CLOUD_GATEWAY",
    "data-name": "CONNECT-MGW8S             IRIS IVDX CLOUD GATEWAY",
    transform: "translate(356.5 244.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 11,
    xmlSpace: "preserve"
  }, "CONNECT-MGW8S             "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 25
  }, "IRIS IVDX CLOUD GATEWAY")), /*#__PURE__*/React.createElement("text", {
    id: "CORAL_TELECOM",
    "data-name": "CORAL TELECOM",
    transform: "translate(37.5 224.5)",
    fill: "#f9f8f8",
    stroke: "#f9f4f4",
    strokeWidth: 1,
    fontSize: 14,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 15
  }, "CORAL"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 34,
    xmlSpace: "preserve"
  }, " TELECOM")), /*#__PURE__*/React.createElement("path", {
    id: "moon-svgrepo-com",
    d: "M37.546,28.464c19.632,0,35.546-5.924,35.546-13.232,0-.612-2.465-.713-3.316-.189-4.046,2.493-11.4,4.159-19.789,4.159-12.761,0-23.105-3.851-23.105-8.6,0-3.125,4.477-5.86,11.173-7.366C39.463,2.918,39.191,2,37.546,2,17.915,2,2,7.924,2,15.232S17.915,28.464,37.546,28.464Z",
    transform: "matrix(0.998, 0.07, -0.07, 0.998, 16.505, 249.979)",
    fill: "#f9f8f8",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "moon-svgrepo-com-2",
    "data-name": "moon-svgrepo-com",
    d: "M35.546,0C15.915,0,0,5.924,0,13.232c0,.612,2.465.713,3.316.189,4.046-2.493,11.4-4.159,19.789-4.159,12.761,0,23.105,3.851,23.105,8.6,0,3.125-4.477,5.86-11.173,7.366-1.408.317-1.136,1.234.509,1.234,19.632,0,35.547-5.924,35.547-13.232S55.178,0,35.546,0Z",
    transform: "translate(31.407 211.268)",
    fill: "#f9f8f8",
    opacity: 0.29
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateway);
export default __webpack_public_path__ + "static/media/Gateway.2b690cea7f039b842ef463c3d116efba.svg";
export { ForwardRef as ReactComponent };